<template>
    <section class="menu-section">
        <header class="flex flex-col items-center gap-y-2 mb-10">
            <h3 class="font-filmotype before-after:h-1.75 before-after:border-y-2 before-after:border-primary before-after:w-full before-after:content-[''] flex w-full items-center justify-center gap-x-5 text-5xl whitespace-nowrap">
                {{ name }}
            </h3>
            <div v-if="description" class="text-center max-w-150" v-html="description"></div>
        </header>

        <div :class="[items.length < 3 ? 'flex justify-center' : 'grid grid-cols-3', 'gap-x-7.5 gap-y-15']">
            <LocationMenuItem v-for="item in items" :key="`menu-item-${item.id}`" v-bind="item" />
        </div>
    </section>
</template>

<script setup>
import LocationMenuItem from './LocationMenuItem.vue';

defineProps({
    id: { type: [Number, String], required: true },
    name: { type: String, required: true },
    description: { type: String, default: null },
    items: { type: Array, required: true },
});
</script>
